import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { identifyMixpanelUser } from "../Utils/mixpanel";
import useAuthState from "../Utils/store";

type Props = { children: React.ReactNode };

const ProtectedRoute = ({ children }: Props) => {
  const location = useLocation();
  const { isLoggedIn, user } = useAuthState();
  if (isLoggedIn()) {
    identifyMixpanelUser(user);
  }
  return isLoggedIn() ? (
    <>{children}</>
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};

export default ProtectedRoute;
